<template>
  <div>
    <div class="public-job-wrapper">
      <div class="landing-wrapper">
        <div class="nav landing-container">
          <div class="nav-left">
            <img
              @click="goToHomePage"
              src="@/assets/static_content/workd.svg"
              class="logo"
            />
          </div>
          <div class="nav-right pc-mode">
            <div
              id="btn-c-accnt-cn-job-prev"
              class="nav-right-content"
              style="color:var(--link-color);cursor:pointer"
              @click="goToSignUp"
            >
              Create account
            </div>
            <div class="nav-right-content">Or</div>
            <div
              id="btn-sgn-in-cn-job-prev"
              class="nav-right-content"
              style="color:var(--link-color);cursor:pointer"
              @click="goToSignIn"
            >
              Sign in
            </div>
            <div
              class="nav-right-button"
              @click="goToEmployer"
              id="btn-c-accnt-emp-job-prev"
            >
              EMPLOYER
            </div>
          </div>
          <div class="nav-right phone-mode">
            <div class="nav-right-button" @click="drawer = !drawer">
              SIGN IN
            </div>
            <div
              class="menu-box"
              v-if="drawer"
              style="border: solid 1px #707070;right:0rem;top:7rem;z-index:100;padding:0.5rem 1rem;position:absolute;box-shadow: 0 7px 11px 0 rgba(0, 0, 0, 0.55);"
            >
              <div
                class="menuitem"
                @click="goToSignIn"
                id="btn-sgn-in-cn-job-prev-phn"
              >
                Candidate Login
              </div>
              <div class="separator"></div>
              <div
                class="menuitem"
                @click="goToEmployer"
                id="btn-c-accnt-emp-job-prev-phn"
              >
                Company Sign in
              </div>
            </div>
            <div
              class="dropdown-wrapper"
              v-if="drawer"
              style="background-color:rgba(0,0,0,0.1);z-index:50"
              @click="drawer = false"
            ></div>
          </div>
        </div>
      </div>
      <div style="padding-bottom: 4rem;" :key="company_id">
        <company-details v-bind:id="company_id"></company-details>
      </div>
      <div class="sixth-section container-new landing-wrapper">
        <div class="landing-container">
          <div class="row">
            <div class="col-sm-2 no-padding" align="left">
              <h3 style="color:white;padding-bottom:1.5rem">
                Download our app
              </h3>
              <img src="@/assets/static_content/google-play-badge.svg" />
            </div>
            <div class="vertical-gap phone-mode"></div>
            <div class="col-sm-6 no-padding" align="left">
              <h3 style="color:white;padding-bottom:1.5rem">Follow us on</h3>
              <img
                src="@/assets/static_content/facebook.svg"
                @click="goToFb"
                style="width:4.2rem"
                class="float"
              />
              <img
                src="@/assets/static_content/linkedin.svg"
                @click="goToIn"
                style="width:4.2rem"
                class="float"
              />
              <img
                src="@/assets/static_content/instagram.svg"
                @click="goToInsta"
                style="width:4.2rem"
                class="float"
              />
              <img
                src="@/assets/static_content/youtube.svg"
                @click="goToYoutube"
                style="width:4.2rem"
                class="float"
              />
            </div>
            <div class="col-sm-4 pc-mode no-padding">
              <div class="row justify-content-end">
                <img
                  class="footer-logo"
                  src="@/assets/static_content/logo-graphics.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer landing-wrapper">
        <div class="landing-container">
          Copyright © 2018 workd. All Rights Reserved
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PHONE } from "../../globalFunctions";
import CompanyDetails from "./company-details-component";
export default {
  name: "company-details-page",
  components: {
    CompanyDetails
  },
  data: function() {
    return {
      drawer: false,
      phone: PHONE(),
      company_id: ""
    };
  },
  methods: {
    goToHomePage() {
      this.$router.push({ name: "landingPage" }).catch(function() {});
    },
    goToSignIn: function() {
      this.$router.push({ name: "signin" }).catch(function() {});
    },
    goToSignUp: function() {
      this.$router.push({ name: "signup" }).catch(function() {});
    },
    goToEmployer() {
      this.$router.push({ name: "employersignup" }).catch(function() {});
    },
    goToFb() {
      window.open("https://www.facebook.com/workdai/", "_blank");
    },

    goToIn() {
      window.open(" https://www.linkedin.com/company/workdai/", "_blank");
    },
    goToInsta() {
      window.open("https://www.instagram.com/workd.ai/", "_blank");
    },
    goToYoutube() {
      window.open(
        "https://www.youtube.com/channel/UCUEeszcZb_-FEgvIQEu2LoQ?view_as=subscriber",
        "_blank"
      );
    }
  },
  mounted() {
    const self = this;
    if (self.$route.query.id) {
      self.company_id = self.$route.query.id;
    }
  }
};
</script>

<style scoped>
.public-job-wrapper {
  background-color: #ffffff;
  padding-bottom: 2rem;
  height: 100vh;
}
.logo {
  cursor: pointer;
  width: 18.5rem;
}
.nav {
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.nav-left {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.nav-left-content > .image > img {
  height: 2.7rem;
  width: auto;
}
.nav-left-content > .content > div {
  color: var(--link-color);
  white-space: nowrap;
}
.nav-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}
.nav-right-content {
  padding-right: 1rem;
}
.nav-right-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  border-radius: 1.7rem;
  background-image: linear-gradient(to left, #3069b3, #8552a1);
  color: white;
  padding: 0rem 2.4rem;
  height: 3.4rem;
}
.phone-mode {
  display: none;
}
.pc-mode {
  display: flex;
}
.sixth-section {
  background-color: var(--landing-color-new);
}
.footer {
  text-align: right;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #00304d;
  color: #87939a;
}
.float {
  float: left;
  margin-right: 2rem;
  margin-bottom: 2rem;
  cursor: pointer;
}
.footer-logo {
  width: 8.6rem;
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
  opacity: 0.3;
  position: absolute;
  right: 0;
  top: 2.2rem;
}
@media (max-width: 800px) {
  .phone-mode {
    display: flex;
  }
  .pc-mode {
    display: none;
  }
}
</style>
